import React from 'react';
import './EventPage.css';

import { PageTitle,Event, Heading } from '../../../components';
import { events } from '../../../constants';



const EventPage = () => {  
  return (  
    <>  
      {/* Page Title */}
      <PageTitle title={'Events'} page={'Events'} />

      {/* Events Section */}
      <section className='events'>

        {/* Section heading */}
        <Heading title={'Upcoming Events'} subTitle={'Join Our Events'} />

        <div className='box-container'>
          {/* Loop through the eventContent array and render each event */}
          {events.map((event) => (
            <Event key={event.id} event={event} />

          ))}
        </div>

      </section>
    </>
  );
}

export default EventPage;